import {Role} from "@/_helpers/role";

export default [
  {
    title: 'Finances',
    icon: 'BoxIcon',
    children: [
      {
        title: 'CashFlow',
        route: 'CashFlow',
      },
      {
        title: 'Salaries payout',
        route: 'Salaries',
      },
    ],
    role: [Role.Admin],
  },
  {
    title: 'Work Pool',
    icon: 'UsersIcon',
    route: 'Clients',
    children: [
      {
        icon: 'CodepenIcon',
        title: 'Projects',
        route: 'Work-Pool-Projects',
      },
      {
        icon: 'ClipboardIcon',
        title: 'Contracts',
        route: 'Work-Pool-Contracts',
      },
    ],
    role: [Role.Admin],
  },
  {
    title: 'Talents',
    icon: 'UsersIcon',
    route: 'Comrades',
    role: [Role.Admin],
  },
  {
    title: 'Reporting',
    icon: 'ClipboardIcon',
    role: [Role.Admin],
    children: [
      {
        title: 'Projects',
        route: 'Reports-Projects',
        icon: 'CodepenIcon',
      },
      {
        title: 'Talents',
        route: 'Reports-Comrades',
        icon: 'UsersIcon',
      },
      {
        title: 'Workloads',
        route: 'Reports-Workloads',
        icon: 'PieChartIcon',
      },
    ],
  },
  {
    title: 'Projects',
    route: 'Reports-Projects',
    icon: 'CodepenIcon',
    role: [Role.Manager]
  },
  {
    title: 'Interviews',
    icon: 'PhoneIcon',
    children: [
      {
        title: 'Interviews',
        route: 'Interviews',
        icon: 'PhoneIcon',
      },
      {
        title: 'Settings',
        route: 'InterviewsSettings',
        icon: 'SettingsIcon',
      },
    ],
    role: [Role.Admin],
  },
  {
    title: 'Settings',
    icon: 'SettingsIcon',
    route: 'Settings',
    role: [Role.Admin],
  },
  {
    title: 'Users',
    icon: 'UserIcon',
    route: 'Users',
    role: [Role.Admin],
  }
]
